/* A&F Auto Paint & Supply — theme.js */
(function () {
  'use strict';

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav ---------- */
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('.mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Stat count-up ---------- */
  var stats = document.querySelectorAll('[data-count]');
  if (stats.length && 'IntersectionObserver' in window &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var statIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        statIO.unobserve(entry.target);
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-count'), 10);
        if (isNaN(target)) return;
        var duration = 1400;
        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(target * eased).toLocaleString('en-US');
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) { statIO.observe(el); });
  }

  /* ---------- Sliding nav pill (Stripe-style hover) ---------- */
  var nav = document.querySelector('.site-nav');
  if (nav && nav.querySelector('a')) {
    var pill = document.createElement('span');
    pill.className = 'site-nav__pill';
    pill.setAttribute('aria-hidden', 'true');
    nav.prepend(pill);
    var moveTo = function (link) {
      pill.style.width = link.offsetWidth + 'px';
      pill.style.height = link.offsetHeight + 'px';
      pill.style.transform = 'translate(' + link.offsetLeft + 'px,' + link.offsetTop + 'px)';
    };
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        if (!pill.classList.contains('is-on')) {
          moveTo(link); // jump instantly on first entry, then glide between items
          pill.getBoundingClientRect();
          pill.classList.add('is-on');
        } else {
          moveTo(link);
        }
      });
      link.addEventListener('focus', function () { moveTo(link); pill.classList.add('is-on'); });
    });
    nav.addEventListener('mouseleave', function () { pill.classList.remove('is-on'); });
    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget)) pill.classList.remove('is-on');
    });
  }

  /* ---------- Back to top ---------- */
  var btt = document.querySelector('[data-btt]');
  if (btt) {
    var bttTick = false;
    var bttUpdate = function () {
      if (bttTick) return;
      bttTick = true;
      requestAnimationFrame(function () {
        btt.classList.toggle('is-on', window.scrollY > 600);
        bttTick = false;
      });
    };
    window.addEventListener('scroll', bttUpdate, { passive: true });
    bttUpdate();
    btt.addEventListener('click', function () {
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    });
  }

  /* ---------- Phone number auto-formatting: (818) 554-5810 ---------- */
  var formatPhone = function (v) {
    var d = v.replace(/\D/g, '');
    if (d.length > 0 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length === 0) return '';
    if (d.length < 4) return '(' + d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  };
  document.querySelectorAll('input[type="tel"]').forEach(function (el) {
    el.addEventListener('input', function (e) {
      // don't fight the user while they're deleting
      if (e.inputType && e.inputType.indexOf('delete') === 0) return;
      var formatted = formatPhone(el.value);
      if (el.value !== formatted) el.value = formatted;
    });
    el.addEventListener('blur', function () {
      el.value = formatPhone(el.value);
    });
  });

  /* ---------- Brand directory filter ---------- */
  var filterWrap = document.querySelector('[data-brand-filters]');
  if (filterWrap) {
    var cards = document.querySelectorAll('[data-brand-cat]');
    filterWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.brand-filter');
      if (!btn) return;
      filterWrap.querySelectorAll('.brand-filter').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
      });
      var cat = btn.getAttribute('data-filter');
      cards.forEach(function (card) {
        var match = cat === 'all' || card.getAttribute('data-brand-cat') === cat;
        card.classList.toggle('is-hidden', !match);
      });
    });
  }
})();
